/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */
import React from 'react'
import UiOfferTimeslotSkeleton from './UiOfferTimeslotSkeleton'

interface UiOfferTimeslotSkeletonsListProps {
    items: number[]
}

const UiOfferTimeslotSkeletonsList = (
    props: UiOfferTimeslotSkeletonsListProps
) => {
    if (!props.items.length) {
        return null
    }

    return (
        <>
            {props.items.map((_, index) => (
                <UiOfferTimeslotSkeleton key={index} index={index} />
            ))}
        </>
    )
}

export default UiOfferTimeslotSkeletonsList
